export const ROLE = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  BUILDER_MANAGER: 3,
  CONSULTANT: 4,
  ROOM_MANAGER: 5,
  SUPPORT_ADMIN: 6,
  INSTALLER: 7,
  STORE_PERSON: 8,
} as const;

const roleMappings: Record<string, string> = {
  "Builder Manager": "Store Manager",
  "Room Manager": "Team Leader",
  Storeperson: "Warehouse",
  "Support Admin": "Operations",
};

export const transformRoleName = (role: string): string => {
  return roleMappings[role] || role;
};

export enum ROLE_ENUM {
  SUPER_ADMIN = "Super Admin",
  ADMIN = "Admin",
  BUILDER_MANAGER = "Builder Manager",
  CONSULTANT = "Consultant",
  ROOM_MANAGER = "Room Manager",
  SUPPORT_ADMIN = "Support Admin",
  INSTALLER = "Installer",
  STORE_PERSON = "Storeperson",
  ACCOUNT_MANAGER = "Account Manager",
}

export const DEFAULT_REDIRECT = "/quotes";

export const roleConstraints = {
  [ROLE_ENUM.INSTALLER]: {
    allowedPages: ["/ws/"],
    defaultRedirect: "/ws/orders/pending",
  },
  [ROLE_ENUM.ACCOUNT_MANAGER]: {
    restrictedPages: ["/ws/", "/ows/"],
    defaultRedirect: DEFAULT_REDIRECT,
  },
};

// Role groups for common permission checks
export const ADMIN_ROLES = [
  ROLE_ENUM.SUPER_ADMIN,
  ROLE_ENUM.ADMIN,
  ROLE_ENUM.SUPPORT_ADMIN,
] as const;

export const SUPPORTED_ROLES = [
  ROLE_ENUM.SUPPORT_ADMIN,
  ROLE_ENUM.ACCOUNT_MANAGER,
] as const;
